import * as React from 'react';
import { useHistory } from 'react-router-dom';
import { useMutation } from 'react-query';
import { notify } from 'services/notification';
import { TRANSPORT_ROUTES } from 'routes/transport-routes';
import { useTranslation } from 'hooks';
import { useCreateTransportRoute } from 'hooks/api/tranpsort-routes';
import { SettingLayout } from 'layouts/SettingLayout';
import { MainContainer } from 'components/shared';
import {
  TransportRouteMap
} from 'pages/Settings/transport-routes/shared-components';

import {
  useTabOptions,
  useForwardTripState,
  useBackwardTripState,
} from '../hooks';
import {
  CreateRouteForm,
  type CreateRouteFormRef,
  CreateRouteSubmissionBar,
} from './components';
import { translations } from './translations';

export const CreateTransportRoutePage = () => {
  const { getTranslation: t } = useTranslation(translations);
  const navigate = useHistory().push;
  const tabOptions = useTabOptions();
  const { clearForwardTripState } = useForwardTripState();
  const { clearBackwardTripState } = useBackwardTripState();
  const { createTransportRoute } = useCreateTransportRoute();

  const createRouteFormRef = React.useRef<CreateRouteFormRef>(null);

  const navigateToListRoutesPage = React.useCallback(() => {
    navigate(TRANSPORT_ROUTES.listRoutes().path);
  }, [navigate]);

  const createRouteMutation = useMutation({
    mutationFn: createTransportRoute,
    onSuccess: () => {
      notify('success', t('routeCreateSuccessMessage'));
      navigateToListRoutesPage();
    },
    onError: (error: any) => {
      notify('error', error?.message);
    },
  });

  const executeFormSubmission = React.useCallback(async () => {
    try {
      const data = await createRouteFormRef.current?.getFormData();
      if (data) {
        createRouteMutation.mutate(data);
      }
    } catch (error) {
      console.error(error);
    }
  }, []);

  React.useEffect(() => {
    return () => {
      clearForwardTripState();
      clearBackwardTripState();
    }
  }, []);

  return (
    <MainContainer>
      <SettingLayout options={tabOptions}>
        <CreateRouteForm
          ref={createRouteFormRef}
          className={'mb-6'}
        />
        <TransportRouteMap className={'mb-6'} />
        <CreateRouteSubmissionBar
          onClickSubmit={executeFormSubmission}
          onClickCancel={navigateToListRoutesPage}
          loading={createRouteMutation.isLoading}
        />
      </SettingLayout>
    </MainContainer>
  );
};